export default __webpack_public_path__ + "static/media/scrum.7d7a6673.png";